export const mediaTypeConstants = {
    LIMIT_FIVE: 5,
    LIMIT_TEN: 10,
    MEDIA_FILE_TYPE: {
        CAMERA: "camera",
        IMAGE: "image"
    },
    MEDIA_SAVE_TYPE: {
        value: "MEDIA_FILE",
        text: "MEDIA_FILE",
        translate: "code.article.file.type.media"
    },
    ATTACHED_SAVE_TYPE: {
        value: "ATTACHED_FILE",
        text: "ATTACHED_FILE",
        translate: "code.article.file.type.attached"
    },
    VIDEO_THUMBNAIL_SIZE: {
        small: 80,
        large_height: 200,
        large_width: 382
    }
};
